import { render, staticRenderFns } from "./SegmentationGroup.vue?vue&type=template&id=23a1aa83&scoped=true"
import script from "./SegmentationGroup.vue?vue&type=script&lang=js"
export * from "./SegmentationGroup.vue?vue&type=script&lang=js"
import style0 from "./SegmentationGroup.vue?vue&type=style&index=0&id=23a1aa83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1aa83",
  null
  
)

export default component.exports